// 创建axios实例
import axios from "axios";
import {injectSessionKey, injectToken} from '@/util/user';

const api = axios.create({
    // baseURL: 'http://local.zone.com',  // 请求的基础URL
    // baseURL: 'http://192.168.12.30:9522',  // 请求的基础URL
    // baseURL: 'http://192.168.133.107:9522',  // 请求的基础URL
    timeout: 30000  // 请求超时时间
});

function isSuccess() {
    return this.code === 0 || this.code === '0';
}

function isFail() {
    return this.code !== 0 && this.code !== '0';
}

// 请求拦截器
api.interceptors.request.use(
    function (config) {
        const headers = config.headers;
        injectToken({headers});
        injectSessionKey({headers})
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(res => {
  res.data.isSuccess = isSuccess;
  res.data.isFail = isFail;
  return res;
});

export default api;

export async function doGet(url, params) {
    let result;
    url = buildGetUrl(url, params)
    await api.get(url)
        .then((res) => {
            result = res.data;
        })
        .catch(error => {
            result = {
                'code': 1,
                'msg': error
            }
        });
    return result;
}

export async function doPost(url, params) {
    let result;
    await api.post(url, params)
        .then((res) => {
            result = res.data;
        })
        .catch(error => {
            result = {
                'code': 1,
                'msg': error
            }
        });
    return result;
}

function buildGetUrl(url, params) {
    if (params) {
        const queryParams = Object.keys(params)
            .filter(key => params[key])
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
            .join("&");
        if (url.indexOf("?") !== -1) {
            return url + "&" + queryParams;
        }
        return url + "?" + queryParams;
    } else {
        return url;
    }
}

export function toFormData(params = {}) {
    const data = new FormData();
    Object.entries(params).forEach(([key, value]) => {
        data.append(key, value);
    });
    return data;
}